<template>
  <div id="ticketSharing">
    <!-- <p class="ticketSharing-header">
      <img
        class="ticketSharing-header-close"
        src="@/assets/tickets/close-l@3x.png"
        alt=""
      />
      <span class="ticketSharing-name">{{ arr.scenic_name }}</span>
    </p> -->
    <div class="ticketSharing-OpenApp">
      <div class="ticketSharing-OpenApp-padd">
        <img
          class="ticketSharing-OpenApp-logo"
          src="@/assets/tickets/logo.png"
          alt=""
        />
        <div class="ticketSharing-text">
          <p class="ticketSharing-text-title">销巴生活App</p>
          <p class="ticketSharing-text-content">好生活就是销巴生活</p>
        </div>
        <template>
          <button
            v-if="isWeixin"
            v-html="renderLoad()"
            class="ticketSharing-openApp-button"
          ></button>
          <button v-else class="ticketSharing-openApp-button" @click="toJoin">
            下载App
          </button>
        </template>
      </div>
    </div>

    <van-swipe
      class="my-swipe"
      :autoplay="3000"
      :show-indicators="false"
      indicator-color="white"
      @change="onChange"
    >
      <van-swipe-item v-for="(item, index) in imageArr" :key="index">
        <img :src="item" alt="" style="width: 100%; height: 100%" />
      </van-swipe-item>

      <template #indicator>
        <div class="custom-indicator">
          {{ current + 1 }}/{{ imageArr.length }}
        </div>
      </template>
    </van-swipe>
    <div class="ticketSharing-bg">
      <div class="ticketSharing-detials">
        <p class="ticketSharing-detials-title">
          <!-- 武汉大标题迪士尼打算的撒打算萨达萨是的大撒上大叔大叔大叔啊 -->{{
            arr.scenic_name
          }}
        </p>
        <span class="detials-score"> {{ arr.score }}分 </span>
      </div>
      <p
        class="ticketSharing-details-content"
        v-if="arr.recommend"
        v-html="
          arr.recommend.length > 28
            ? arr.recommend.slice(0, 29) + '...'
            : arr.recommend
        "
      >
        <!-- “看万里长城山河壮丽,万里长城上看醉人秋色撒打算算的…” -->
      </p>
      <p class="ticketSharing-details-content" style="margin-top: 1rem">
        <span>开园时间</span>
        <span class="details-time" v-if="arr.open_time">
          <!-- 夏令时10:00-24:00 冬10:00-24: -->
          {{
            arr.open_time.length > 27
              ? arr.open_time.slice(0, 28) + "..."
              : arr.open_time
          }}
        </span>
        <span class="details-see">
          <span class="details-see-left" @click="handSee">查看</span>
          <img src="@/assets/tickets/right.png" alt="" />
        </span>
      </p>
      <div class="details-address">
        <span class="details-address-left">
          <!-- 上海市 松江区广富林路3260弄广富林文化遗址内 -->
          {{ arr.address }}
        </span>
        <div class="details-address-operation">
          <!-- <div class="details-take" @click="DonwLoadApp">
            <p><img src="@/assets/tickets/take.png" alt="" /></p>
            <p>打车</p>
          </div> -->

          <!-- <template>
            <div
              class="details-take"
              v-if="isWeixin"
              v-html="renderTake()"
            ></div>
            <div class="details-take" v-else @click="toJoin">
              <p><img src="@/assets/tickets/take.png" alt="" /></p>
              <p>打车</p>
            </div>
          </template> -->

          <template>
            <div
              class="details-take"
              v-if="isWeixin"
              v-html="renderMap()"
            ></div>
            <div class="details-take" v-else @click="toJoin">
              <p><img src="@/assets/tickets/Map.png" alt="" /></p>
              <p>地图</p>
            </div>
          </template>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
    <div class="spotTickets">
      <p class="spotTickets-title">景区门票</p>
      <div style="width: '100%" class="spotTicketsList">
        <!-- :class="[isOpen ? 'active' : 'on']" -->
        <div
          class="spotTickets-list"
          v-for="(item, index) in ticketProducts"
          :key="index"
          v-if="isOpen || index < max"
        >
          <div>
            <div class="spotTickets-left">
              <p class="spotTickets-left-Adult-ticket">
                <!-- 成人票（70周岁含以上老人/军人/残疾人） -->
                {{ item.product_name }}
              </p>
              <p class="Discounted-money" v-if="item.discounts_price != 0">
                已优惠{{ item.discounts_price }}元
              </p>
              <p class="spotTickets-left-explain">
                <span
                  style="margin-right: 0.4rem"
                  @click="Retreat(item.product_id)"
                >
                  <span style="line-height: 1rem"> 购票说明</span>
                  <img src="@/assets/tickets/explain-right.png" alt=""
                /></span>
                <span
                  style="margin-right: 0.4rem"
                  @click="ticketNotice(item.product_id)"
                >
                  <span style="line-height: 1rem">退改说明</span>
                  <img src="@/assets/tickets/explain-right.png" alt=""
                /></span>
              </p>
            </div>
            <div class="spotTickets-right">
              <p class="spotTickets-right-money" v-if="item.line_price != 0">
                ¥{{ item.line_price }}
              </p>
              <p class="spotTickets-right-price">
                <span>￥</span>
                <span style="font-size: 1.2rem; font-weight: bold">{{
                  item.sale_price
                }}</span>
              </p>
              <template>
                <p
                  class="spotTickets-choose"
                  v-if="isWeixin"
                  v-html="renderShop()"
                ></p>
                <p class="spotTickets-choose" v-else @click="toJoin">选购</p>
              </template>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>

      <div
        class="ticket-vanButton"
        type="primary"
        v-show="
          !isOpen && arr.ticketProducts && arr.ticketProducts.length > max
        "
        @click="isOpen = !isOpen"
      >
        查看更多
        <van-icon name="arrow-down" />
      </div>
      <div
        class="ticket-vanButton-Stow"
        v-show="isOpen && arr.ticketProducts && arr.ticketProducts.length > max"
        @click="isOpen = !isOpen"
      >
        收起
        <van-icon name="arrow-up" />
      </div>

      <div class="BookingInstructions" v-if="arr.bookNotice">
        <p class="spotTickets-title">预订须知</p>
        <div class="spotTickets-list">
          <div
            class="spotTickets-list-item"
            v-for="(item, index) in arr.bookNotice"
            :key="index"
            :class="[index != arr.bookNotice.length - 1 ? 'active' : 'on']"
          >
            <p class="spotTickets-list-item-name">{{ item.key }}</p>
            <p class="spotTickets-list-item-text" v-html="item.value"></p>
          </div>
        </div>
      </div>

      <div class="BookingInstructions" v-if="scenicDescription">
        <p class="spotTickets-title">景区介绍</p>
        <div class="spotTickets-list">
          <div
            class="Scenic-spot-introduction"
            v-html="scenicDescription"
          ></div>
        </div>
      </div>
    </div>

    <div class="Scenic-spot-tickets">
      <span class="Scenic-spot-tickets-text">景点门票</span>

      <template>
        <span v-if="isWeixin" v-html="renderDom()"></span>
        <span v-else @click="toJoin">App内打开</span>
      </template>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      :style="{
        height: '80%',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
      }"
      closeable
    >
      <div class="BookingInstructions">
        <!--购票说明-->
        <div class="BookingInstructions-div" style="padding-bottom: 10px">
          <p class="Quick-reply">预定说明</p>
          <div
            v-for="(item, index) in book_notice"
            :key="index"
            :class="item.key != '出票速度' ? 'BookingInstructions-padd' : ''"
          >
            <div v-if="item.key != '出票速度'">
              <p class="BookingDetails-title">
                <span class="BookingDetails-title-key">
                  {{ item.key }}
                </span>
                <span v-html="item.value" class="BookingDetails-content-text">
                </span>
              </p>
              <div style="clear: both"></div>
            </div>
          </div>
          <p
            v-if="book_notice == '' || book_notice == null || book_notice == []"
            class="BookingDetails-information"
          >
            暂无信息
          </p>
        </div>

        <div class="BookingInstructions-div">
          <p class="Quick-reply">费用说明</p>
          <div
            v-for="(item, index) in cost_description"
            :key="'info' + index"
            class="BookingInstructions-padd"
          >
            <p class="BookingDetails-title">
              {{ item.key }}
            </p>
            <p v-html="item.value" class="BookingDetails-content"></p>
          </div>
          <p
            v-if="
              cost_description == '' ||
              cost_description == null ||
              cost_description == []
            "
            class="BookingDetails-information"
          >
            暂无信息
          </p>
        </div>
        <div class="BookingInstructions-div">
          <p class="Quick-reply">其他说明</p>
          <div
            v-for="(item, index) in other_description"
            :key="'info1' + index"
            class="BookingInstructions-padd"
          >
            <p class="BookingDetails-title">
              {{ item.key }}
            </p>
            <p v-html="item.value" class="BookingDetails-content"></p>
          </div>

          <p
            v-if="
              other_description == '' ||
              other_description == null ||
              other_description == []
            "
            class="BookingDetails-information"
          >
            暂无信息
          </p>
        </div>
        <div class="BookingInstructions-div">
          <p class="Quick-reply">使用说明</p>
          <div
            v-for="(item, index) in use_description"
            :key="'info2' + index"
            class="BookingInstructions-padd"
          >
            <p class="BookingDetails-title">
              {{ item.key }}
            </p>
            <p v-html="item.value" class="BookingDetails-content"></p>
          </div>
          <p
            v-if="
              use_description == '' ||
              use_description == null ||
              use_description == []
            "
            class="BookingDetails-information"
          >
            暂无信息
          </p>
        </div>
        <div class="BookingDetails-day">
          <p>*以上信息仅供参考，具体以景点当日实际公告信息为准</p>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showRule"
      position="bottom"
      :style="{
        height: '80%',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
      }"
      closeable
    >
      <div class="SinglePageDescription">
        <div class="BookingInstructions-div">
          <p class="Quick-reply">退改说明</p>
          <div
            v-for="(item, index) in refund_change_rule"
            :key="'info3' + index"
            class="BookingInstructions-padd"
          >
            <p class="BookingDetails-title">
              {{ item.key }}
            </p>
            <p v-html="item.value" class="BookingDetails-content"></p>
          </div>

          <p
            v-if="
              refund_change_rule == '' ||
              refund_change_rule == null ||
              refund_change_rule == []
            "
            class="BookingDetails-information"
          >
            暂无信息
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>


<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      arr: {},
      max: 3,
      show: false,
      showRule: false,
      isOpen: false,
      imageArr: [],
      current: 0,
      iosApp: false,
      scenicDescription: "",
      isiOS: false,
      downUrl: "",
      url: "",
      scenic_id: "",
      isWeixin: false,
      isBan: false,
      refund_change_rule: [],
      book_notice: [],
      cost_description: [],
      other_description: [],
      use_description: [],
      short_name: "",
      ticketProducts: [],
    };
  },
  created() {
    var u = navigator.userAgent;
    this.isWeixin = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
    if (this.isWeixin) {
      this.wxconfig();
    }
    if (this.$route.query.scenic_id) {
      this.scenic_id = this.$route.query.scenic_id;
      this.TicketDetails();
      //  const extinfo = this.TicketDetails();
    }
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (
      u.toLowerCase().indexOf("qq") > -1 &&
      u.toLowerCase().indexOf("mqqbrowser") < 0 &&
      isIOS
    ) {
      this.isBan = true;
    }

    // let ua = navigator.userAgent.toLowerCase();
    // if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
    //   this.isiOS = true;
    //   this.downUrl = "http://itunes.apple.com/cn/app/id1273703378?ls=1&mt=8";
    //   this.url =
    //     "ShallBuyLife123://" + `?scenic_id=${this.$route.query.scenic_id}`;
    // } else {
    //   this.isiOS = false;
    //   this.downUrl =
    //     "http://a.app.qq.com/o/simple.jsp?pkgname=com.shallbuy.xiaoba.life";
    //   this.url = "xblife://" + `?scenic_id=${this.$route.query.scenic_id}`;
    // }
  },

  mounted() {
    
  },
  methods: {
    wxconfig(){
this.$api
      .post("member/index/wechat/get/sign/package", {
        type: 2,
        url: location.href,
      })
      .then((res) => {
        wx.config({
          debug: false,
          appId: res.appId,
          nonceStr: res.nonceStr,
          signature: res.signature,
          timestamp: res.timestamp,
          jsApiList: ["checkJsApi"],
          openTagList: ["wx-open-launch-app"],
        });
      });
    },
    handleError(e) {
      console.log("error", e, e.detail);
      // 跳到下载download.html页面
      // Dialog.alert({ message: "error:" + JSON.stringify(e.detail) });
    },

    handleLaunch(e) {
      console.log("success", e, e.detail);
      // Dialog.alert({ message: "success:" + JSON.stringify(e) });
    },

    renderTake() {
      let _script = document.createElement("script");
      _script.type = "text/wxtag-template";
      _script.text =
        "<style>   .details-take {display: inline-block;margin-left: 1rem;} .img {width: 1.5rem;} </style>";
      _script.text += `<div class="details-take" >
            <p><img class="img" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAACYFJREFUeF7tm31wVNUZxp/n7G4SQAP1Y1qVdkZaGcWO2olilkAbhDF+DFIEItlNQEpbq05tZ2rtKK2N49fU6kxr6+dUqSQbIFFRGapYKHH42KAyI05FR1s60yJ1KlpAEbKbPU/npjXshr25dz+Spc7ef8973vd5f/e955x77rlE+RqSAMt8hiZQBuRRIWVAZUCFDSLlCjrmK0hiTReqRyVh0rUGR0P1O3CgtZW2sBoorHdpK0jihTHMJRQBGUxPhZI1hqtDbyPW3cq+wtLMv3dJAdWtVG2qTx0ATs+eAvfI4OptEf4x/xQL61kyQBcv15iPA/itBRZBctdBPl2VwJLuxdxXWKr59S4ZoCkxfd1KqwGc4CH9IAybeiJck1+KhfUqGaDamNZCusyn/O3xKC8gKZ/2RTMrHqBWmfpzUZ08gGpVItTXi4CbykAAEwXlVhEBLrYJbHXzGaxEir1IhqpxoHsHDqBIs19RANWt0Kkpi9kEGgSdBXEcgQq3ZARVAhiVy20mcBjgYXefSIDaR/BNAesCBs9uaeKeXGJksy0YUN0KnW/79JCIs3NNulDxQ/Q/ROINY3jtlia+WkicggBNXq7TjUEHoNpCRAxj3222gk0vN/Jv+cYoCFC4XQ8Luibf4CPRj+Sj8Sjz1pg3oHBMkyW9BKBqJBLNPwYPw6K+ZyG35eMjL0DzOxX4RwK/B9ScFlQAXzcBLD3xOGxcM4uf5CMo3z6z1mj0Bx9juk3hTkDnADiSGxn7YgiLuhqZytV/XoDCHToTVusEfGkgoPC+CXDB1gj/lKuIYtpP6dBFNqWVIE7+1C+Bv8OwIR7hW7nGyg9Qu66XdB8IZ7ruvwiuTRzEnO3XMJmriGLa1zyiUMXxWC2rywe0Cb0gfxRv5gO5xsoZ0HnLNK4qpMcBzEkPRsM58QifyVXAcNiHV2iOUno60zdXVyXxrVzf6XIGNLlN5xpqPYCT0ks4MZZnbR/hcccNbs0aja7YjzcFHRkCgL1BcebmFu7I5abkDGhKe+oOCy7NqB7w7ngzb8kl8HDbhjt0l6xuTo9jwDu3NvOnucTOCZAzU7y/H7sAfT4tyEFDTt0a5Wu5BB5u2ymdOs8mtBnAmCOx+K/qkzHhxQYe9Bs/J0DhmJZI+t2gZ3tDlcGC7gj3+g06EnbTHtfJiUqtpHBRRjzD7/REOCgHd0W+AYU7NUoJbAR0YZq7lCHvOC2E2/NZYwwnKGet9m4SP7OS80il7SxwGyswPd7IQ37i+wfUrhmCVqYPzgD2MsAF8SZu8BNspG3CKzRDzpoobULp1wwuiDf70+wLkLO2CI6xtxG8Kf1ukHzVCjO2NfPASCfvJ15Np8aGEnJuXk161dPwnsRE/Hz7+d5rNl+AprXplD6DZyRNzhBGLu2J8i4/YktlU9uupYDuyJx18UpQnL2phf/00uUJ6JzlGjM6iItotVppzzKJ3soqfqV7Lnd7BSlle/1TGt97WH+R0lf9SCnAKz9JYsPrC4ee0VwBXfoHVf57PxqYsrNBfkPClzPuAvlsPMpvljJ5v7HDMTnVPztTP/4K6SUFzLOfG4t1z1/G3mz+sgKaLwV2t+NXoqIAxmW8GQ944Q4Rb/sVWUo7ChMBnZtFg/MRYB/J2PgIftjFo9/2jwLkLAb3HsD9kpaUMqmRjk3ysZOqccPgbZoMQK2tMi+cgYUQ7gd0/EiLLG08fgTihkvewfL08wAZgCY/oRNNAG2ALi2t2FJF5/M2hZaXF/GDTxUMBjTRBBQf6munM3tJiBvykUAIGwLAoVQSk5IWV9NgniTnLd9zdhwmBCK5V0JXiHgiEMLOFDAqlcQMK11DIpw+m2XR8KFNMfzyIg6MrRmJ1HVoaspqk5t4AimRdyeJX28f9O5Vv1HBQ3twsRF+I2jCMAEY0i3BXZb4/qhT8WL39MwTITUdOikk/IDSzenLlcEOA4bTtkTovOT2XxmAamO6EtJTrioMl1X14rruxdk/4Dlj2PqJuLzP6rlSAAoaXjHzbax1O1NUv0xVhyvxIKwWu+oj5/ZEObDZlgEoHNN8SZ3Z1wPcF6xA3aZG7vRKPtyujYLqveyK2U6wO97M6V4+p3VqUl8CWwQ5y5ejLpKN8Si7slbQkICIeF+CV76ymO95iQh36MeyusfLrpjtNLwpHuEvvXxesExfCFboaQnhYgNal+pjNH2EdxMTjmmhpCe8xBaz3ZALt0bZ5uXTmakDQcUkNBQb0KtByyv8vOCF21O3CrzNS2wx2yneGm/h7V4+//virecknF9UQAA+hjirp4XdQ4n438Za3GVp76W/gHbuYAXCXhthtW2qB/uP3hxXbEDOpLel6jTM7J7ufgyldoV+gpScLZCMU6sFZO63q0WAt/Q08RduHeo3qurwu1gPqM7NJu9BemBUN3ySlbjxtBR2p2+zXtiuakPMh3Cv2wzhN9N87QjuA3GjFbrSN/H6t18DGK9e3CureUP5LxgQAOf79ms0XAvgLVokLXAKYaeKbIAwNt8Ei9KP2E9pHWg2UXhPBiEAZ0K4TNLXMvenizjNZxHvHPA+CNJCck6LuZ4oK0riuTtJgDwEyXnUnU8/vh75YlRQ7lL/j3qUAXncrDKgMqDCnudyBZUrqFxBhREopILqOnR2KoX5R/kw+Cqkue7Lc7whyyeHVXmOzmk0T+o/3J79Ip+CxZ8HNwYC6NoS4RsDbw5+4oY71CTb/1+XW7RVPc1c4MfXSNnUtjuHFnSVq2LDSDzCFV56fG2uh9v6mkQzBCCt6mkOHGOAUisBugOSjcRbgmVArhVUTEBTYlpgJXfa5MqeKJu8ynUk22vbh64gQzZtjdI5OzTk5e8RW6UGJfXCEAPeQz1RXucVbCTba2N6ENK1rhUU4iXxq7jOS5MvQM7sZi02Z93ncf4CtPhuT4v/c39eoorRXtumb8Pg0Wz/wzr7RsZgavps5QrSj5j+zTDoMQFZNpu4M0jM2hzlLj++RspmakwT+oQ1gCYNjkngSQsu8XMyzlcFOQFqY5oJqwdgeMaRu8K9BFrHV+DhY/EQ5+4EviegFej/HA70V7vegeH1PVE6h+E9L9+AHE9TY6qxRKO1djyFD2nM+n0hPL+zkQnPSCUwmNSpinFJXCprZ4o4wRiz2widm6Pc7ldOToAcp843+OQujDr1ePR2HaNgBic/v1MVez5CZWgCDg3+Zu8FKmdAXg4/a+1lQMVYB33WqiKXfMoVVK6gXOrlaNtyBXnw+w/UTQqF21+EbAAAAABJRU5ErkJggg==" alt="" /></p><p>打车</p>
          </div>`;
      const extinfo = encodeURIComponent(
        JSON.stringify({
          type: "ticketSharing",
          scenic_id: this.scenic_id,
          id: this.scenic_id,
          short_name: this.$route.query.short_name,
          img: this.$route.query.img,
        })
      );
      let html = `<wx-open-launch-app  class="btn" appid="wxc1265f98df56cd07" extinfo="${extinfo}" > ${_script.outerHTML} </wx-open-launch-app> `;
      return html;
    },

    renderMap() {
      let _script = document.createElement("script");
      _script.type = "text/wxtag-template";
      _script.text =
        "<style>   .details-take {display: inline-block;margin-left: 1rem;} .img {width: 1.5rem;} </style>";
      _script.text += `<div class="details-take" >
            <p style="margin-top:0px;"><img class="img" style="width:25px;" src="http://h5.dev.shall-buy.top/img/Map.ff262e68.png" alt="" /></p><p style="color:#999999;margin-top:-15px;font-size:.8rem;text-align:center;">地图</p>
          </div>`;
      const extinfo = encodeURIComponent(
        JSON.stringify({
          type: "ticketSharing",
          scenic_id: this.scenic_id,
          id: this.scenic_id,
          short_name: this.$route.query.short_name,
          img: this.$route.query.img,
        })
      );
      let html = `<wx-open-launch-app  class="btn" appid="wxc1265f98df56cd07" extinfo="${extinfo}" > ${_script.outerHTML} </wx-open-launch-app> `;
      return html;
    },

    renderLoad() {
      let _script = document.createElement("script");
      _script.type = "text/wxtag-template";
      _script.text =
        "<style> .ticketSharing-openApp-button {   float: right;border: none;outline: none;background: linear-gradient(90deg, #fea40a, #ff7e0c);color: #fff;border-radius: 2.4rem;font-size: 0.8rem;padding-bottom: 0.3rem;} </style>";
      _script.text += `<button  class="ticketSharing-openApp-button" >下载App </button>`;
      const extinfo = encodeURIComponent(
        JSON.stringify({
          type: "ticketSharing",
          scenic_id: this.scenic_id,
          id: this.scenic_id,
          short_name: this.$route.query.short_name,
          img: this.$route.query.img,
        })
      );
      let html = `<wx-open-launch-app  class="btn" appid="wxc1265f98df56cd07" extinfo="${extinfo}" > ${_script.outerHTML} </wx-open-launch-app> `;
      return html;
    },

    renderShop() {
      let _script = document.createElement("script");
      _script.type = "text/wxtag-template";
      _script.text =
        "<style> .spotTickets-choose { color: #fff;text-align: center;border-radius: 2.4rem;margin-top: 0.5rem;height:0px;line-height:.5rem} </style>";
      _script.text += `<p class="spotTickets-choose" >选购</p>`;
      const extinfo = encodeURIComponent(
        JSON.stringify({
          type: "ticketSharing",
          scenic_id: this.scenic_id,
          id: this.scenic_id,
          short_name: this.$route.query.short_name,
          img: this.$route.query.img,
        })
      );
      let html = `<wx-open-launch-app  class="btn" appid="wxc1265f98df56cd07" extinfo="${extinfo}" > ${_script.outerHTML} </wx-open-launch-app> `;
      return html;
    },

    renderDom() {
      let _script = document.createElement("script");
      _script.type = "text/wxtag-template";
      _script.text =
        "<style> .btn { color:#fff;font-size: 0.7rem;display:inline-block;} </style>";
      _script.text += `<div class="btn">App内打开</div>`;
      const extinfo = encodeURIComponent(
        JSON.stringify({
          type: "ticketSharing",
          scenic_id: this.scenic_id,
          id: this.scenic_id,
          short_name: this.$route.query.short_name,
          img: this.$route.query.img,
        })
      );
      let html = `<wx-open-launch-app  class="btn" appid="wxc1265f98df56cd07" extinfo="${extinfo}" > ${_script.outerHTML} </wx-open-launch-app> `;
      return html;
    },

    toJoin() {
      if (this.isBan) {
        return this.$toast("请在浏览器中打开");
      }
      this.openApp(
        null,
        null,
        `?type=ticketSharing&scenic_id=${this.scenic_id}&id=${this.scenic_id}&short_name=${this.$route.query.short_name}&img=${this.$route.query.img}`
      );
    },

    ticketNotice(product_id) {
      // this.$router.push({
      //   path: "/tickets/binglePageDescription",
      //   query: { product_id: product_id },
      // });
      this.showRule = true;
      this.$api
        .post("third-tickets/index/ticket/detail", {
          short_name: "PanHe",
          product_id: product_id,
        })
        .then((res) => {
          //退改说明
          this.refund_change_rule = res.refund_change_rule;
        });
    },
    Retreat(product_id) {
      // this.$router.push({
      //   path: "/tickets/bookingInstructions",
      //   query: { product_id: product_id },
      // });
      this.show = true;
      this.$api
        .post("third-tickets/index/ticket/detail", {
          short_name: "PanHe",
          product_id: product_id,
        })
        .then((res) => {
          //购票说明
          this.book_notice = res.book_notice;
          this.cost_description = res.cost_description;
          this.other_description = res.other_description;
          this.use_description = res.use_description;
        });
    },

    DonwLoadApp() {
      //  let baseUrl = process.env.VUE_APP_WEEX_HOST
      //      this.parmSrc =
      //         `/tickets/ticketSharing?scenic_id=${this.scenic_id}`
      //         var that=this;
      //        that.openApp('', '', this.parmSrc)

      window.location.href = this.url;

      setTimeout(() => {
        let hidden =
          window.document.hidden ||
          window.document.mozHidden ||
          window.document.msHidden ||
          window.document.webkitHidden;
        console.log(window.document.hidden, "window.document.hidden");
        if (typeof hidden == "undefined" || hidden == false) {
          window.location.href = this.downUrl;
        }
      }, 2000);
    },
    handSee() {
      Dialog.alert({
        confirmButtonColor: "linear-gradient(90deg, #04D1A3, #02D4D0)",
        confirmButtonText: "我已知晓",
        message: `开园时间：${this.arr.open_time}`,
        theme: "round-button",
      }).then(() => {
        // on close
      });
    },
    onChange(index) {
      this.current = index;
    },

    TicketDetails() {
      this.$api
        .post("third-tickets/index/scenic/detail", {
          short_name: "PanHe",
          scenic_id: this.$route.query.scenic_id,
        })
        .then((res) => {
          this.arr = res;
          this.ticketProducts = res.ticketProducts;
          this.imageArr = res.images;
          this.scenicDescription = res.scenicDescription;
          this.short_name = res.short_name;
          document.title = res.scenic_name;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.SinglePageDescription {
  background: #fff;

  .Quick-reply {
    color: #333;
    font-weight: bold;
    padding-top: 25px;
    margin-bottom: 15px;
    padding-left: 20px;
  }
  .BookingInstructions-div {
    border-bottom: 5px solid #f3f8fb;
    padding-bottom: 20px;

    .BookingDetails-information {
      color: #666;
      font-size: 13px;
      font-weight: bold;
      padding-left: 20px;
    }
    .BookingInstructions-padd {
      padding: 0px 20px;
      margin-top: 20px;
      border-bottom: 1px solid #efefef;
      padding-bottom: 15px;
    }
    .BookingInstructions-padd:last-of-type {
      border-bottom: none;
    }
  }

  .BookingDetails-title {
    color: #333;
    font-size: 13px;
    font-weight: bold;
  }

  .BookingDetails-content {
    font-size: 13px;
    color: #999;
    line-height: 20px;
    background: #fff;

    margin-top: 10px;
    /deep/ img {
      width: 100%;
      margin: 10px 0px;
    }
  }
}
.BookingInstructions {
  // background: #ffffff;
  overflow: hidden;

  .BookingDetails-day {
    font-size: 13px;
    color: #666;
    line-height: 60px;
    background: #fff;
    border-bottom: 5px solid #f3f8fb;
    p {
      margin-left: 20px;
    }
  }
  .BookingInstructions-padd {
    padding: 0px 20px;
    margin-top: 9px;
    border-bottom: 1px solid #efefef;
    padding-bottom: 12px;
  }
  .BookingInstructions-padd:last-of-type {
    border-bottom: none;
  }
  .Quick-reply {
    color: #333;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 15px;
    padding-left: 20px;
  }
  .BookingInstructions-div {
    border-bottom: 5px solid #f3f8fb;
    padding-bottom: 10px;

    .BookingDetails-information {
      color: #666;
      font-size: 13px;
      font-weight: bold;
      padding-left: 20px;
    }
  }

  .BookingDetails-title {
    color: #333;
    font-size: 13px;
    font-weight: bold;

    .BookingDetails-content-text {
      float: right;
      width: 70%;
      font-weight: normal;
      color: #333333;
      vertical-align: middle;
      margin-top: 15px;
      line-height: 23px;
    }
    .BookingDetails-title-key {
      float: left;
      padding: 3px 5px;
      background: #fff5ed;
      color: #ff7500;
      margin-top: 15px;
    }
  }

  .BookingDetails-content {
    font-size: 13px;
    color: #666;
    line-height: 20px;
    background: #fff;

    margin-top: 10px;
    /deep/ img {
      width: 100%;
      margin: 10px 0px;
    }
  }
}
.btn {
  width: 100%;
  height: 4.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: #fff;
  font-weight: 700;
  border-radius: 2.1rem;
  background: linear-gradient(270deg, #ff003f 0%, #ff6900 100%);
}
.my-swipe .van-swipe-item {
  position: relative;
  color: #fff;
  font-size: 20px;
  text-align: center;
  margin-top: 3.5rem;
  // background-color: #39a9ed;
}
.custom-indicator {
  position: absolute;
  padding: 0.3rem 0.9rem;
  background: rgba(000, 000, 000, 0.2) !important;
  color: #fff;
  bottom: 1.8rem;
  right: 1rem;
  border-radius: 1rem;
}

.ticketSharing-bg {
  position: relative;
  z-index: 110;
  background: #fff;
  margin-top: -1rem;
  padding-bottom: 0.25rem;
  border-top-left-radius: 0.7rem;
  border-top-right-radius: 0.7rem;
}
#ticketSharing {
  background: #f3f8fb;

  .Scenic-spot-tickets {
    position: fixed;
    min-width: 3rem;
    padding: 0.5rem 0.7rem;
    background: linear-gradient(90deg, #fea40a, #ff7e0c);
    font-size: 0.9rem;
    color: #fff;
    bottom: 2rem;
    left: 7rem;
    border-radius: 1.4rem;
    box-shadow: 0px 0px 0.7rem #ff8f00;
    .Scenic-spot-tickets-text {
      display: inline-block;
      background: #fff;
      color: #ff8f00;
      padding: 0.3rem 0.6rem;
      border-radius: 1rem;
      font-size: 0.7rem;
      margin-right: 0.6rem;
    }
  }
  .spotTickets {
    padding: 1rem 0.5rem;
    .active {
      max-height: auto;
    }
    .on {
      max-height: 22rem;
    }
    .spotTicketsList {
      overflow: hidden;
    }
    .BookingInstructions {
      margin-top: 1.2rem;
    }
    .ticket-vanButton,
    .ticket-vanButton-Stow {
      background: #fff;
      border-radius: 2rem;
      color: #00b2af;
      padding: 0.4rem 0.7rem;
      height: auto;
      border: none;
      margin: 0 auto;
      max-width: 5rem;
      text-align: center;
      margin-top: 15px;
      font-size: 0.9rem;
    }
    .ticket-vanButton-Stow {
      max-width: 3rem;
    }
    .spotTickets-list {
      background: #fff;
      border-radius: 0.5rem;
      padding: 1rem;
      margin: 1rem 0rem;
      .Scenic-spot-introduction {
        color: #666666;
        font-size: 0.8rem;
        line-height: 1.3rem;
      }
      .on {
        padding-bottom: 0rem;
      }
      .active {
        padding-bottom: 2rem;
      }
      .spotTickets-list-item {
        font-size: 0.8rem;

        .spotTickets-list-item-name {
          color: #333333;
          font-weight: bold;
        }
        .spotTickets-list-item-text {
          color: #666666;
          margin-top: 0.7rem;
        }
      }
      .spotTickets-right {
        float: right;
        .spotTickets-right-money {
          font-size: 0.7rem;
          color: #999999;
          text-decoration: line-through;
          text-align: center;
          margin-bottom: 0.4rem;
        }
        .spotTickets-choose {
          background: linear-gradient(90deg, #fea40a, #ff7e0c);
          color: #fff;
          padding: 0.5rem 1.2rem;
          text-align: center;
          border-radius: 1.4rem;
          line-height: 1.2rem;
          margin-top: 0.5rem;
        }
        .spotTickets-right-price {
          color: #ff6f00;
        }
      }
      .spotTickets-left {
        display: inline-block;
        width: 74%;

        .Discounted-money {
          background: #ffebc3;
          color: #b87135;
          font-size: 0.7rem;
          display: inline-block;
          margin-top: 1.1rem;
          padding: 0.2rem;
          border-radius: 0.2rem;
        }
        .spotTickets-left-explain {
          color: #666666;
          font-size: 0.7rem;
          margin-top: 1.5rem;
          span {
            img {
              width: 0.6rem;
            }
          }
        }
        .spotTickets-left-Adult-ticket {
          color: #333333;
          font-weight: bold;
          font-size: 0.9rem;
          overflow: hidden;

          text-overflow: ellipsis;

          white-space: nowrap;
        }
      }
    }
    .spotTickets-title {
      font-size: 1rem;
      color: #333333;
      font-weight: bold;
      margin-top: 0.5rem;
    }
  }
  .details-address {
    margin: 0.5rem;
    font-size: 0.9rem;
    background: #f3f8fb;
    padding: 0.5rem 1rem;

    .details-address-operation {
      float: right;
      text-align: center;
      color: #999999;
      font-size: 0.7rem;
      .details-take {
        display: inline-block;
        margin-left: 1rem;
        img {
          width: 1.5rem;
        }
      }
    }
    .details-address-left {
      display: inline-block;
      width: 67%;
      color: #333333;
    }
  }
  .ticketSharing-details-content {
    color: #0086f5;
    padding: 0.5rem;
    font-size: 0.9rem;
    .details-see {
      float: right;
      color: #444444;
      .details-see-left {
        display: inline-block;
        vertical-align: top;
      }
      img {
        width: 0.8rem;
        vertical-align: middle;
      }
    }
    .details-time {
      color: #444444;
      margin-left: 0.7rem;
    }
  }
  .ticketSharing-detials {
    padding-top: 0.7rem;
    .detials-score {
      float: right;
      background: #0086f5;
      color: #fff;
      padding: 0.2rem 0.6rem;
      border-top-left-radius: 0.7rem;
      border-top-right-radius: 0.6rem;
      border-bottom-right-radius: 0.6rem;
      font-size: 0.8rem;
      margin-right: 0.5rem;
    }
    .ticketSharing-detials-title {
      display: inline-block;
      color: #333333;
      font-size: 1.1rem;
      width: 82%;
      font-weight: bold;
      margin-left: 0.5rem;
      line-height: 1.7rem;
    }
  }
  .ticketSharing-OpenApp {
    position: fixed;
    top: 0rem;
    background: #ffffff;
    width: 100%;
    left: 0px;
    z-index: 200;
    .ticketSharing-OpenApp-padd {
      padding: 0.6rem 1rem;
    }
    .ticketSharing-openApp-button {
      float: right;
      border: none;
      outline: none;
      background: linear-gradient(90deg, #fea40a, #ff7e0c);
      color: #fff;
      border-radius: 2.4rem;
      padding: 0.5rem 1.1rem;
      line-height: 1rem;
      font-size: 0.8rem;
      margin-top: 0.4rem;
    }
    .ticketSharing-text {
      display: inline-block;
      margin-left: 0.5rem;
      line-height: 1.2rem;
      .ticketSharing-text-title {
        color: #333333;
      }
      .ticketSharing-text-content {
        font-size: 0.4rem;
        color: #999999;
        margin-top: 0.2rem;
      }
    }
    .ticketSharing-OpenApp-logo {
      width: 2.3rem;
    }
  }
  .ticketSharing-header {
    background: #ededed;
    text-align: center;
    padding: 0.7rem 0rem;
    .ticketSharing-header-close {
      float: left;
      width: 1.5rem;
      margin-left: 1rem;
    }
    .ticketSharing-name {
      color: #333333;
      font-weight: bold;
      padding-right: 2rem;
    }
  }
}
</style>